import { GetRegion } from 'constants.js';
import { getUserId } from 'utils/User';
import { getHKS } from './HKS';

//TODO REVISAR IMPLEMENTACIÓN DE NEWRELIC LLEVA MUCHO TIEMPO SIN FUNCIONAR

export default class Metrics {
  constructor(data) {
    this.data = data;
  }

  eventList(event) {
    const all = {
      event: null,
    };

    const events = {
      common: {
        eventCategory: 'perfil',
        eventAction: 'click',
        eventLabel: null,
      },
    };

    events[event].event = all.event;
    return events[event];
  }

  updateData(obj) {
    const buildNewObj = Object.assign(obj);

    const self = this;
    Object.keys(buildNewObj).forEach(key => {
      if (buildNewObj[key] == null) {
        buildNewObj[key] = self.data[key];
      }
    });

    return { tagManager: buildNewObj };
  }

  setMetrics(event) {
    const newEvent = this.eventList(event);
    const tagmanager = this.updateData(newEvent);
    return tagmanager;
  }

  setMetricsQuick(event) {
    if (event === 'common') {
      if (!this.data['eventCategory']) {
        this.data['eventCategory'] = this.data['event'];
      }
    }

    return { tagManager: this.data };
  }
}


export const wasEventPageSendedToNewRelic = page => {
  const metricsWasSended = Boolean(
    sessionStorage.getItem(`newrelic-page-event-${page}`),
  );
  return metricsWasSended;
};

export const sendEventPageToNewRelic = ({ page, payload = {} }) => {
  if (wasEventPageSendedToNewRelic(page)) return;

  // TODO: Esto no debe estár de ésta manera, se debe generalizar y los
  // valores debén leerse de constante establecidas
  const body = {
    region: GetRegion(),
    HKS: getHKS(),
    device_id: 'web',
    device_category: 'web',
    device_manufacturer: 'generic',
    device_model: 'web',
    device_type: 'web',
    ...payload,
  };
  const cleanBody = JSON.parse(JSON.stringify(body));
  try {
    newrelic.addPageAction(page, cleanBody);
    sessionStorage.setItem(`newrelic-page-event-${page}`, 'sended');
  } catch (error) {
    sessionStorage.removeItem(`newrelic-page-event-${page}`);
  }
};

export const removeNewRelicFlags = () => {
  Object.keys(sessionStorage)
    .filter(k => k.indexOf('newrelic-page-event-') >= 0)
    .forEach(k => sessionStorage.removeItem(k));
};

export const updateNewRelicParams = (payload = {}) => {
  const params = {
    HKS: getHKS(),
    user_id: getUserId(),
    device_id: 'web',
    device_category: 'web',
    device_manufacturer: 'generic',
    device_model: 'web',
    device_type: 'web',
    ...payload,
  };
  try {
    Object.keys(params).forEach(param => {
      newrelic.setCustomAttribute(param, params[param]);
    });
  } catch (error) {
  }
};

export const setNewRelicParam = (params = {}) => {
  try {
    Object.keys(params).forEach(param => {
      newrelic.setCustomAttribute(param, params[param]);
    });
  } catch (error) {
  }
};
